export default __webpack_public_path__ + "static/media/Instagram.5360fe5f.svg";